import { render, staticRenderFns } from "./CMS-registration.vue?vue&type=template&id=4cbe4bab&"
import script from "./CMS-registration.vue?vue&type=script&lang=js&"
export * from "./CMS-registration.vue?vue&type=script&lang=js&"
import style0 from "./CMS-registration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports